import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Input } from '@ibk/shared-ui';
import { usePixKeyInput } from '../../hooks/usePixKeyInput';
import styles from './PixKeyInput.module.css';
function PixKeyInputBase(props) {
    const { dataTestId = 'pixKeyInput' } = props;
    const { validationResult, getPlaceholder, getInputType, isDisabled, handleInputChange, handleInputBlur, getStepTitle, getInputLabel, getInputDataTestId, shouldRenderInputField, } = usePixKeyInput(props);
    const renderInputField = () => {
        if (!shouldRenderInputField()) {
            return null;
        }
        return (_jsx(Input, { dataTestId: `${dataTestId}${getInputDataTestId()}`, size: 'large', type: getInputType(props.selectedKeyType), placeholder: getPlaceholder(props.selectedKeyType), value: props.value, onChange: handleInputChange, onBlur: handleInputBlur, error: validationResult.error, label: getInputLabel(), disabled: isDisabled(props.selectedKeyType) }));
    };
    return (_jsxs("section", { className: styles.container, "data-testid": dataTestId, children: [_jsx("h2", { className: styles.stepTitle, "data-testid": `${dataTestId}Title`, children: getStepTitle() }), _jsx("div", { className: styles.inputContainer, "data-testid": `${dataTestId}InputContainer`, children: renderInputField() })] }));
}
export const PixKeyInput = React.memo(PixKeyInputBase);
